export default "__VITE_ASSET__Bs2oU4J3__"